import { render, staticRenderFns } from "./goDetails.vue?vue&type=template&id=71ba1064&scoped=true&"
import script from "./goDetails.vue?vue&type=script&lang=js&"
export * from "./goDetails.vue?vue&type=script&lang=js&"
import style0 from "./goDetails.vue?vue&type=style&index=0&id=71ba1064&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ba1064",
  null
  
)

export default component.exports